<template>
    <div id="timer">
        <p class="time">0:00</p>
    </div>
</template>

<script>
    export default {
        name: 'Timer',
        data () {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #timer {
        position: absolute;
        top: 10%;
        left:0;
        right:0;
        margin:0 auto;
    }
    .time {
        font-size: 120px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Timer.vue